import { VALIDATION_ERROR_ISSUES } from "../../../../../constants";
import messages from "./enter-verification-code-form-messages";
const { INVALID_CODE } = VALIDATION_ERROR_ISSUES;

export default {
  [`verificationCode_${INVALID_CODE}`]: messages.invalidCode
};
